var map = {
	"./back.svg": 34,
	"./defaultPic.svg": 19,
	"./delete-icon.svg": 35,
	"./dev-united-logo.svg": 36,
	"./dev-united-naming.svg": 37,
	"./google-icon.svg": 38,
	"./like-off.svg": 39,
	"./like-on.svg": 40,
	"./logout-icon.svg": 41
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;